module.exports = __webpack_public_path__ + "img/apex.f7edba44.svg";